import * as qs from 'qs';

const parseItmObject = itm =>
    Object.assign(
        {},
        ...Object.keys(itm).map(key => ({
            [`itm_${key}`]: itm[key]
        }))
    );

/**
 * Converts an itm object to query string
 * @param {Object} itm - Object containing the itm properties
 * @param {string} itm.source - Reference to the referring location/page e.g: 'vip'
 * @param {string} itm.medium - Reference to the unique element e.g 'suggest-from-blueshift'
 */
const itmToQueryString = itm =>
    !itm ? '' : `?${qs.stringify(parseItmObject(itm))}`;

/**
 * Converts itm to query string and appends it to given url
 * @param {string} url
 * @param {Object} itm - See definition above
 * @returns {string}
 */
const decorateUrlWithItm = (url, itm) => {
    if (!url || !itm) {
        return url;
    }

    const itmQueryString = parseItmObject(itm);
    const stringified = qs.stringify(itmQueryString);

    return url.includes('?')
        ? `${url}&${stringified}`
        : `${url}?${stringified}`;
};

export { itmToQueryString, decorateUrlWithItm };
